<template>
    <Card :title="$route.meta.title" dis-hover>
        <Spin size="large" fix v-if="tableLoading"></Spin>
        <div slot="extra">
            <span style="margin-right:10px;"><Button type="primary" @click="toggleFold">{{isFold?'展开':'折叠'}}</Button></span>
            <!--<Button type="success" @click="handleOpen(null,'add')">添加一级地区</Button>-->
        </div>
        <tree-table :expand-type="false" :is-fold="isFold" :selectable="false" :columns="treeColumns"
                    :data="placeList">
            <template slot-scope="{row}" slot="level">
                <span>{{row.level}}级</span>
            </template>
            <template slot-scope="{row}" slot="operation">
                <span class="operation-btn">
                    <Button type="primary" @click="handleOpen(row,'edit')">修改</Button>
                </span>
                <span class="operation-btn">
                    <Button type="error" @click="handleOpen(row,'delete')">删除</Button>
                </span>
                <span v-if="row.level==1" class="operation-btn">
                    <Button type="success" @click="handleOpen(row,'add')">添加下级地区</Button>
                </span>
            </template>
        </tree-table>
        <Modal v-model="modalVisible" :title="modalTitle">
            <Spin size="large" fix v-if="modalLoading"></Spin>
            <Form ref="baseForm" :model="modalForm" :label-width="100">
                <FormItem label="地区名称" prop="placeName" :rules="[rules.required]">
                    <Input v-model="modalForm.placeName" placeholder="地区名称"></Input>
                </FormItem>
                <FormItem label="民政部名称" prop="govName" :rules="[rules.required]">
                    <Input v-model="modalForm.govName" placeholder="民政部名称"></Input>
                </FormItem>
                <FormItem label="上级地区" v-if="modalForm.parentName!=null">
                    <Input :value="modalForm.parentName" disabled></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="modalVisible = false">取消</Button>
                <Button type="primary" @click="handleSubmit">确定</Button>
            </div>
        </Modal>
    </Card>
</template>
<script>
    import iSetting from '@/module/base/api/iSetting'
    import rules from '@/libs/rules';
    import _don from '@/libs/doson'

    const modalFormTemplate = {
        id: null,
        parentId: null,
        placeName: null,
        govName:null,
        parentName:null
    };

    export default {
        name: "place_mng",
        mixins: [],
        components: {

        },
        data() {
            return {
                rules,
                placeLevel:1,
                placeList: [],
                treeColumns: [
                    {title: '地区名称', key: 'placeName', width: '300px'},
                    {title: '级别', type:'template' , template: 'level', width: '100px'},
                    {title: '添加时间', key: 'addTime', minWidth: '100px'},
                    {title: '操作', type: 'template', template: 'operation'}
                ],
                modalForm:_don.cloneWithModal(modalFormTemplate),
                tableLoading:false,
                modalVisible:false,
                modalLoading:false,
                modalTitle:'',
                isFold:false
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                this.getTableData()
            },
            getTableData() {
                iSetting.placeList(this.placeLevel).then(res => {
                    this.placeList = res
                });
            },
            handleOpen(row, type) {
                if (type === 'edit') {
                    this.$refs.baseForm.resetFields();
                    _don.cloneWithModal(modalFormTemplate, this.modalForm, row);
                    this.$nextTick(() => {
                        this.modalTitle = '修改地区'
                        this.modalVisible = true;
                    });
                    return;
                }
                if (type === 'add') {
                    this.$refs.baseForm.resetFields();
                    this.modalForm = _don.cloneWithModal(modalFormTemplate);
                    if (row) {
                        this.modalForm.parentId = row.id
                        this.modalForm.parentName = row.placeName
                    }
                    this.$nextTick(() => {
                        this.modalTitle = '添加地区'
                        this.modalVisible = true;
                    });
                    return;
                }
                if (type === 'delete') {
                    if (row.children && row.children.length > 0) {
                        this.$Message.error('存在下级地区，无法删除');
                        return;
                    }
                    this.$Modal.confirm({
                        title: '提示',
                        content: `该操作将删除地区“${row.placeName}”，确认继续？`,
                        onOk: () => {
                            iSetting.deletePlace(row.id).then(() => {
                                this.placeList = this.removePlace(this.placeList, row.id)
                                this.$Message.success('操作成功');
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                }
            },
            removePlace(list, id) {
                list = list.filter(e => {
                    if (e.children && e.children.length > 0) {
                        e.children = this.removePlace(e.children, id)
                    }
                    return e.id != id
                })
                return list
            },
            handleSubmit() {
                this.$refs.baseForm.validate(val => {
                    if (!val) return;
                    // 更新数据
                    if (this.modalForm.id == null) {
                        iSetting.addPlace(this.modalForm).then(() => {
                            this.init();
                            this.modalVisible = false;
                            this.$Message.success('操作成功');
                        }).loadingSwitch(this, 'modalLoading');
                    } else {
                        iSetting.updatePlace(this.modalForm).then(() => {
                            this.init();
                            this.modalVisible = false;
                            this.$Message.success('操作成功');
                        }).loadingSwitch(this, 'modalLoading');
                    }
                });
            },
            toggleFold() {
                this.isFold = !this.isFold
            }
        }
    }
</script>

<style scoped lang="less">

</style>
